<div #hook  class="payment"></div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/payments/adyen-payment.component.html